import { contactData } from '@/mocks/homeData';

export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-primary-100 text-primary-700 rounded-full mb-3 whitespace-nowrap">
            <i className="ri-mail-send-line mr-1"></i>等你来爆
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950">
            投稿爆料
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            {contactData.desc}
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/60 rounded-2xl p-6 md:p-8">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            <div className="flex items-start gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-primary-100 shrink-0">
                <i className="ri-mail-line text-primary-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">投稿邮箱</div>
                <div className="mt-1 text-sm text-foreground-600">{contactData.email}</div>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center rounded-lg bg-accent-100 shrink-0">
                <i className="ri-wechat-line text-accent-600 text-lg"></i>
              </div>
              <div>
                <div className="text-sm font-semibold text-foreground-900">微信联系</div>
                <div className="mt-1 text-sm text-foreground-600">{contactData.wechat}</div>
              </div>
            </div>
          </div>

          <div className="mt-6 md:mt-8 pt-6 border-t border-background-200/60">
            <div className="text-sm font-semibold text-foreground-900 mb-3">投稿须知</div>
            <div className="space-y-2">
              {contactData.tips.map((tip) => (
                <div key={tip} className="flex items-center gap-2">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 shrink-0">
                    <i className="ri-information-line text-accent-600 text-xs"></i>
                  </div>
                  <span className="text-xs md:text-sm text-foreground-600">{tip}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="mt-8 text-center">
            <a
              href={`mailto:${contactData.email}`}
              className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white font-semibold rounded-xl transition-colors text-sm whitespace-nowrap"
            >
              立即投稿
              <i className="ri-arrow-right-line"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}